/** @jsx jsx */
import { useEffect } from 'react';

const DEFAULT_TITLE = 'The best apps. Better together.';
const DEFAULT_SECONDARY_TITLE = ' | Zapier';

/**
 * Updates the page title
 * @param title
 */
const useDocumentTitle = (title = DEFAULT_TITLE) => {
  useEffect(() => {
    document.title = `${title}${DEFAULT_SECONDARY_TITLE}`;
  }, [title]);
};

export default useDocumentTitle;
